{
  "closing": "Closing",
  "schedule-closing": "Schedule closing"
}
